import { RadioButton, ReactEasyForm } from "@aeco-cloud/react-easy-form";
import settings from "@styles/settings";
import { useContext } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { TextContext } from "../../../pages/bepaal-statuut";
import { Label, NavigationButtons, Question, Section } from "../../form-layout";
import StepBody from "../../form-layout/StepBody";
import { SendContext } from "../BepaalStatuut";

const Mutualiteit = () => {
  const text = useContext(TextContext);
  const send = useContext(SendContext);
  const form = useForm();

  const onSubmit: SubmitHandler<any> = (data) => {
    const result =
      data.benefit === "true" && data.benefitHalf === "true"
        ? "secondaryActivityTrue"
        : "secondaryActivityFalse";
    data.result = result;
    send({ type: "NEXT", data: data });
  };

  const onBack = () => {
    send({ type: "BACK" });
  };

  return (
    <ReactEasyForm form={form}>
      <StepBody>
        <Section>
          <Question>
            <Label label={text.mutualiteit_benefit_label} />
            <RadioButton
              name="benefit"
              minButtonWidth="240px"
              {...settings.selectButtonsProps}
              options={[
                { value: "true", label: text.general_yes },
                { value: "false", label: text.general_no },
              ]}
              rules={{
                required: text.general_requiredQuestion,
              }}
            />
          </Question>
          <Question showIf={form.watch("benefit") === "true"}>
            <Label label={text.mutualiteit_benefit_benefitHalf_label} />
            <RadioButton
              name="benefitHalf"
              minButtonWidth="240px"
              {...settings.selectButtonsProps}
              options={[
                { value: "true", label: text.general_yes },
                { value: "false", label: text.general_no },
              ]}
              rules={{
                required: text.general_requiredQuestion,
              }}
            />
          </Question>
        </Section>
      </StepBody>
      <NavigationButtons onBack={onBack} onNext={form.handleSubmit(onSubmit)} />
    </ReactEasyForm>
  );
};
export default Mutualiteit;
